<template>
    <ui-slider
        :slides-per-view="{ desktop: 3, mobile: 'auto' }"
        mobile-auto
        no-shadow
        dark
        class="premium-price-card-slider"
    >
        <div
            class="premium-price-card-slider__item"
            v-for="(item, i) in items"
            :key="i"
            :slot="i"
        >
            <PremiumPriceCard
                v-bind="item"
            />
        </div>
    </ui-slider>
</template>
<script>
/* eslint-disable no-irregular-whitespace */
import PremiumPriceCard from './PremiumPriceCard.vue';

export default {
    components: {
        PremiumPriceCard,
    },
    data() {
        return {
            items: [
                {
                    name: 'ИНТРО',
                    title: 'Среднемесячный остаток 1,5&nbsp;-&nbsp;3&nbsp;млн&nbsp;₽&nbsp;или от&nbsp;200&nbsp;тыс.&nbsp;₽ средняя зарплата за 2&nbsp;мес. + покупки по карте от&nbsp;50&nbsp;тыс.&nbsp;₽/мес.',
                    options: [
                        {
                            content: 'До 2 проходов в бизнес-залы в&nbsp;месяц',
                            tooltip: 'При среднемесячном остатке от 2 до 3 млн ₽ за предыдущий месяц или от 200 тыс. ₽ средняя зарплата за 2 мес. + покупки по карте от 50 тыс. ₽/мес.',
                            disabled: false,
                        },
                        {
                            content: 'Консьерж-сервис',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Налоговые и юридические консультации',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Консультации по подбору элитной недвижимости',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Компенсация поездок<br>на такси',
                            tooltip: '',
                            disabled: true,
                        },
                        {
                            content: 'Накопительный счёт Ультра',
                            tooltip: '',
                            disabled: true,
                        },
                    ],
                    price: {
                        value: 2000,
                        text: 'В остальных случаях',
                    },
                    actionLink: '#form',
                },
                {
                    name: 'СТАНДАРТ',
                    title: 'Среднемесячный остаток<br>3&nbsp;-&nbsp;6&nbsp;млн&nbsp;₽',
                    options: [
                        {
                            content: '4 прохода в бизнес-залы в&nbsp;месяц',
                            tooltip: 'При среднемесячном остатке от 3 до 6 млн ₽ за предыдущий месяц',
                            disabled: false,
                        },
                        {
                            content: 'Консьерж-сервис',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Налоговые и юридические консультации',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Консультации по подбору элитной недвижимости',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Компенсация 3&nbsp;поездок на такси<br>в&nbsp;год',
                            tooltip: `Доступно возмещение 3&nbsp;поездок на&nbsp;такси в&nbsp;год (но&nbsp;не&nbsp;более 1&nbsp;в&nbsp;месяц), при условии среднемесячных остатков за&nbsp;предыдущий месяц от&nbsp;3&nbsp;млн&nbsp;₽ до&nbsp;6&nbsp;млн&nbsp;₽. Банк компенсирует операции по&nbsp;коду МСС: 4121, 4789, 3990, при условии осуществления оплаты премиальной картой Тарифного&nbsp;плана&nbsp;7&nbsp;&laquo;Мультивалютный&raquo;. Максимальная сумма компенсации за&nbsp;одну поездку не&nbsp;более 2&nbsp;тыс.&nbsp;₽. Компенсация производится не&nbsp;позднее 20&nbsp;числа месяца, следующего за&nbsp;месяцем, в&nbsp;котором была осуществлена поездка.`,
                            disabled: false,
                        },
                        {
                            content: 'Накопительный счёт Ультра',
                            tooltip: '',
                            disabled: true,
                        },
                    ],
                    price: {
                        text: 'При несоблюдении условия держатель пакета услуг переводится на уровень Интро',
                    },
                },
                {
                    name: 'УЛЬТРА',
                    title: 'Среднемесячный остаток<br>от&nbsp;6&nbsp;млн&nbsp;₽',
                    options: [
                        {
                            content: 'До 8 проходов в бизнес-залы в&nbsp;месяц',
                            tooltip: '2 прохода - при среднемесячном остатке от 2 до 3 млн ₽ за предыдущий месяц<br><br>4 прохода - при среднемесячном остатке от 3 до 6 млн ₽ за предыдущий месяц<br><br>8 проходов при среднемесячном остатке от  6 млн ₽ за предыдущий месяц',
                            disabled: false,
                        },
                        {
                            content: 'Консьерж-сервис',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Налоговые и юридические консультации',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Консультации по подбору элитной недвижимости',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Компенсация 12&nbsp;поездок на такси<br>в год',
                            tooltip: `Доступно возмещение 12&nbsp;поездок на&nbsp;такси в&nbsp;год (но&nbsp;не&nbsp;более 2&nbsp;в&nbsp;месяц), при условии среднемесячных остатков за&nbsp;предыдущий месяц от&nbsp;6&nbsp;млн&nbsp;₽. Банк компенсирует операции по&nbsp;коду МСС: 4121, 4789, 3990, при условии осуществления оплаты премиальной картой Тарифного плана 7&nbsp;&laquo;Мультивалютный&raquo;. Максимальная сумма компенсации за&nbsp;одну поездку не&nbsp;более 2&nbsp;тыс.&nbsp;₽. Компенсация производится не&nbsp;позднее 20&nbsp;числа месяца, следующего за&nbsp;месяцем, в&nbsp;котором была осуществлена поездка.`,
                            disabled: false,
                        },
                        {
                            content: 'Накопительный <a class="link" href="/savings-account/ultra/">счёт Ультра</a>',
                            tooltip: '',
                            disabled: false,
                        },
                        {
                            content: 'Чекап <a class="link js-anchor" href="#premium-card-accordeon__3">здоровья</a>',
                            tooltip: '',
                            disabled: false,
                        },
                    ],
                    price: {
                        value: 6000,
                        text: 'В остальных случаях',
                    },
                    actionLink: '#form',
                    accent: true,
                },
            ],
        };
    },
};
</script>
<style lang="scss">
@import "/local/templates/redesign/src/assets/scss/base/_variables.scss";
@import "/local/templates/redesign/src/assets/scss/base/_mixins.scss";
@import "/local/templates/redesign/src/assets/scss/base/_functions.scss";

.premium-price-card-slider {
    @include fluid(margin-left, -16px, -8px);
    @include fluid(margin-right, -16px, -8px);

    &__item {
        @include fluid(padding-left, 16px, 8px);
        @include fluid(padding-right, 16px, 8px);

        @include mobile {
            @include fluid(width, 304px);
        }
    }
}
</style>
